




















import { defineComponent, onMounted, ref } from '@vue/composition-api';

const CommonPanelWithExpandable = defineComponent({
  setup(props: any) {
    const showSlot = ref(false);
    onMounted(() => {
      showSlot.value = props.initOpen;
    });

    return {
      showSlot,
    };
  },
  props: {
    title: {
      default() {
        return '';
      },
    },
    subtitle: {
      default() {
        return '';
      },
    },
    initOpen: {
      default() {
        return false;
      },
    },
  },
});

export default CommonPanelWithExpandable;
